// Muss zuerst laden: Anmeldung (Token/Benutzer) je Browser-Tab statt global
import "@/utils/tabSession";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installChunkErrorHandlers } from "@/utils/versionReload";
import { installLangDruecken } from "@/utils/langDruecken";
import { installTabellenKarten } from "@/utils/tabellenKarten";

// Veraltete Programmteile nach einem Deployment abfangen (statt Fehlerseite neu laden)
installChunkErrorHandlers();

// Handy/Tablet: langes Drücken öffnet die Rechtsklick-Menüs
installLangDruecken();

// Handy: Listentabellen (Klasse ew-karten) als Karten – Spaltenüberschriften an die Zellen schreiben
installTabellenKarten();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA Service-Worker registration with auto-update on new version
if ('serviceWorker' in navigator) {
  let reloadGuard = false;

  // Auto-reload once when the active SW changes (new version takes over).
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloadGuard) return;
    reloadGuard = true;
    console.log('[SW] Controller changed — reloading to pick up new bundle');
    window.location.reload();
  });

  // Listen for activation message broadcast from sw.js
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'sw-activated' && !reloadGuard) {
      reloadGuard = true;
      console.log('[SW] Activated message received — reloading');
      window.location.reload();
    }
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((reg) => {
        console.log('[SW] registered:', reg.scope);
        // Force update check on every page load
        reg.update().catch(() => {});
      })
      .catch((err) => console.warn('[SW] registration failed:', err));
  });
}
